import './App.css';
import Home from './pages/Home/Home';

function App() {  
  return (
    <div className="App">
      <h2>PLEX RENAMER</h2>
      <Home />
    </div>
  );
}

export default App;
